module.exports = __webpack_public_path__ + "static/media/leaf-1.3fe0bc58.svg";